export default "__VITE_ASSET__BUULNkMD__"